import React from 'react';
import { observer } from 'mobx-react';
import { Trans } from 'react-i18next';
import PropTypes from 'prop-types';

import { routeNode, routerStore } from 'core/routing';
import { useAppManager, useClientStore } from 'apps/hooks';

import { useGetSystemCondition } from 'hooks';
import { MainWrapper } from 'legacyComponents/styled/lib';
import { RepoSpinner } from 'apps/repository/styles';
import {
  SideNavBarWrapper,
  SideNavBar,
  SideNavBarItem,
  SideNavBarLink,
  SettingsWrapper,
} from 'legacyComponents/sideNavBar';

import { FourOhFour } from '../../fourOhFour';
// import { Home } from './tabs/home';
import { TeamSettings } from './tabs/team';
import { BillingSettings } from './tabs/billing';
import { InitiativeRouterAppManager } from './appManager';

const viewsMap = {
  // '': Home,
  teams: TeamSettings,
  billing: BillingSettings,
};

const InitiativeSettings = observer(props => {
  const clientStore = useClientStore();
  const { isSmallerThanM } = clientStore.breakPointManager;
  const { shouldShowFrameSideBar } = useGetSystemCondition();
  const manager = useAppManager(InitiativeRouterAppManager, null, {}, true, [
    props.route.params.spacePath,
  ]);

  const View = props.componentFromRoute();
  const { loading, notFound, isAllowed } = manager;

  if (loading) {
    return (
      <MainWrapper marginBottom='90px'>
        <RepoSpinner />
      </MainWrapper>
    );
  }

  if (notFound || !isAllowed) {
    return <FourOhFour />;
  }
  const { route } = props;
  const initiativeParam = {
    spacePath: route.params.spacePath,
  };

  return (
    <>
      <MainWrapper>
        <div className='inline-block w-full mt-8'>
          <SideNavBarWrapper style={{ top: 0 }}>
            <SideNavBar
              shouldFixed={!isSmallerThanM}
              shouldShowFrameSideBar={shouldShowFrameSideBar}
            >
              <SideNavBarItem data-testid='initiativePage-members-navLink'>
                <SideNavBarLink
                  name='workspace.spaceSettings.teams'
                  params={initiativeParam}
                  active={route.name.includes('teams')}
                >
                  <Trans>Members</Trans>
                </SideNavBarLink>
              </SideNavBarItem>
              <SideNavBarItem last data-testid='initiativePage-billing-navLink'>
                <SideNavBarLink
                  name='workspace.spaceSettings.billing'
                  params={initiativeParam}
                  active={route.name.includes('billing')}
                >
                  <Trans>Billing</Trans>
                </SideNavBarLink>
              </SideNavBarItem>
            </SideNavBar>
          </SideNavBarWrapper>
          <SettingsWrapper id='settingWrapper'>
            <View
              params={props.routerStore.params}
              initiativeManager={manager}
            />
          </SettingsWrapper>
        </div>
      </MainWrapper>
    </>
  );
});

class RedirectToTeam extends React.Component {
  constructor(props) {
    super(props);
    const {
      route: { params },
    } = routerStore;
    routerStore.navigate(`workspace.spaceSettings.teams`, params, {
      replace: true,
    });
  }

  render() {
    return null;
  }
}

RedirectToTeam.propTypes = {
  clientStore: PropTypes.object,
};

InitiativeSettings.propTypes = {
  route: PropTypes.object,
  routerStore: PropTypes.object,
  componentFromRoute: PropTypes.func,
};

export const InitiativeSettingsRouter = routeNode(
  'workspace.spaceSettings',
  viewsMap,
  RedirectToTeam,
)(InitiativeSettings);
